import React from 'react';
import { ShoppingCartIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '../common/Tooltip';
import { Quotation } from '../../types/quotation';
import { useLanguage } from '../../contexts/LanguageContext';
import toast from 'react-hot-toast';

interface QuotationToOrderButtonProps {
  quotation: Quotation;
  onOrderCreated?: (orderId: string) => void;
  showTooltip?: boolean;
  className?: string;
  disabled?: boolean;
}

const QuotationToOrderButton: React.FC<QuotationToOrderButtonProps> = ({ 
  quotation,
  onOrderCreated,
  showTooltip = true,
  className = "text-gray-400 hover:text-red-400",
  disabled = false
}) => {
  const { t } = useLanguage();

  const handleCreateOrder = () => {
    // Tiltott funkció toast üzenet
    toast.error('Tiltott funkció');
  };

  const buttonContent = (
    <button
      onClick={handleCreateOrder}
      className={`${className} flex items-center transition-colors opacity-75 cursor-not-allowed`}
      aria-label="Megrendelés (letiltva)"
    >
      <ShoppingCartIcon className="h-4 w-4" />
    </button>
  );

  if (showTooltip) {
    return (
      <Tooltip content="Tiltott funkció - Jelenleg nem elérhető">
        {buttonContent}
      </Tooltip>
    );
  }

  return buttonContent;
};

export default QuotationToOrderButton; 